import src from "IMAGE";
export default { src, width: 2049, height: 1152, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAPElEQVR42o3KoQ0AIAwAwZLgsGzAAmzBAAgcY7AAg5dvgkCRijOfF1WVH/EM4RFRrmzNhoqOiYaFjYF0AA/yYoZwkiZ4AAAAAElFTkSuQmCC"};
